import {
    CONFIRMED_GET_DISEASE_HISTORY,
  } from "../actions/DiseaseHistoryTypes.js";
  
  const initialState = {
    diseaseHistory: [],
  };
  
  export default function DiseaseHistoryReducer(state = initialState, action) {
    if (action.type === CONFIRMED_GET_DISEASE_HISTORY) {
      return {
        ...state,
        diseaseHistory: action.payload,
      };
    }
  
    return state;
  }
  